module.exports = __webpack_public_path__ + "static/media/program-info-icon-active-yellow.a8b4fcb2.svg";